import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import PropTypes from 'prop-types';
import React from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import classnames from 'classnames';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import styles from './set-link-modal.scss';
var _React_Component;
class SetLinkModal extends (_React_Component = React.Component) {
    render() {
        const { url, isValid } = this.state;
        const { componentData: { title, description, placeholder, showRemoveLink, errorMessage } } = this.props;
        const hasError = url && !isValid;
        return /*#__PURE__*/ React.createElement("div", {
            className: this.styles.container,
            onKeyDown: this.handleKeyDown
        }, /*#__PURE__*/ React.createElement("button", {
            className: this.styles['close-button'],
            onClick: this.onCloseRequested
        }), /*#__PURE__*/ React.createElement("div", {
            className: this.styles.content
        }, /*#__PURE__*/ React.createElement("div", {
            className: this.styles.heading
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: styles['input-wrapper']
        }, /*#__PURE__*/ React.createElement(TextInput, {
            id: "editor-link-url-input",
            key: "urlInput",
            type: "text",
            label: description || '',
            validationResult: hasError ? 'error' : undefined,
            value: url || '',
            tabIndex: 1,
            onChange: this.onChange,
            className: styles.input,
            placeholder: placeholder,
            details: hasError ? errorMessage : undefined,
            autoFocus: true
        }))), /*#__PURE__*/ React.createElement("div", {
            className: styles.footer
        }, showRemoveLink && /*#__PURE__*/ React.createElement(TextButton, {
            size: "medium",
            variant: "main",
            className: classnames(styles.removeButton, url && styles.removeButton_active),
            onClick: this.removeLink,
            disabled: !url
        }, "Remove link"), /*#__PURE__*/ React.createElement("button", {
            className: styles.confirmButton,
            onClick: this.onConfirm
        }, "Submit")));
    }
    constructor(props){
        super(props);
        _define_property(this, "styles", void 0);
        _define_property(this, "onChange", (ev)=>{
            const url = ev.target.value;
            const { componentData: { validateUrl } } = this.props;
            const isValid = validateUrl(url);
            this.setState({
                url,
                isValid
            });
        });
        _define_property(this, "onConfirm", ()=>{
            const { url } = this.state;
            const { componentData, componentData: { validateUrl, updateUrl }, helpers, pubsub, onConfirm } = this.props;
            if (validateUrl(url)) {
                if (onConfirm) {
                    onConfirm(_object_spread_props(_object_spread({}, componentData), {
                        src: url
                    }));
                }
                updateUrl(url, pubsub, helpers);
                this.onCloseRequested();
            } else {
                this.setState({
                    isValid: false
                });
            }
        });
        _define_property(this, "removeLink", ()=>{
            const { componentData: { updateUrl }, helpers, pubsub } = this.props;
            this.setState({
                url: '',
                isValid: true
            });
            updateUrl('', pubsub, helpers);
            this.onCloseRequested();
        });
        _define_property(this, "onCloseRequested", ()=>{
            this.props.helpers.closeModal();
        });
        _define_property(this, "handleKeyDown", (e)=>{
            if (e.key === 'Enter') {
                setTimeout(()=>this.onConfirm());
            }
        });
        this.styles = mergeStyles({
            styles: styles,
            theme: props.theme
        });
        const { componentData: { getUrl }, pubsub } = this.props;
        this.state = {
            url: props.componentData.inputAlwaysEmpty ? '' : getUrl(pubsub),
            isValid: true
        };
    }
}
_define_property(SetLinkModal, "propTypes", {
    onConfirm: PropTypes.func,
    pubsub: PropTypes.object,
    helpers: PropTypes.object.isRequired,
    componentData: PropTypes.object.isRequired,
    url: PropTypes.string,
    theme: PropTypes.object.isRequired,
    t: PropTypes.func
});
_define_property(SetLinkModal, "defaultProps", {
    onChange: ()=>{
    // noop
    }
});
export { SetLinkModal as default };

//# sourceMappingURL=SetLinkModal.js.map